const primary = "hsl(var(--primary))";
const secondary = "hsl(var(--secondary))";
const mutedFill = "hsl(var(--foreground) / 0.14)";
const strokeW = 2;

function SimplePerson({
  x,
  y,
  color = primary,
  scale = 1,
}: {
  x: number;
  y: number;
  color?: string;
  scale?: number;
}) {
  return (
    <g transform={`translate(${x},${y}) scale(${scale})`} aria-hidden="true">
      <circle cx={12} cy={8} r={7} stroke={color} strokeWidth={strokeW} />
      <rect
        x={4}
        y={16}
        width={16}
        height={18}
        rx={6}
        stroke={color}
        strokeWidth={strokeW}
      />
    </g>
  );
}

type UgaHeroIllustrationProps = {
  className?: string;
};

export function UgaHeroIllustration({ className }: UgaHeroIllustrationProps) {
  return (
    <svg
      viewBox="0 0 320 220"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Open book and competency grid connected to a small learning community"
      className={className}
    >
      <g aria-hidden="true">
        {/* Open book */}
        <path
          d="M24 168 L24 72 Q56 56 88 72 L88 168 Q56 152 24 168 Z"
          fill={mutedFill}
          stroke={primary}
          strokeWidth={strokeW}
          strokeLinejoin="round"
        />
        <path
          d="M88 72 Q120 56 152 72 L152 168 Q120 152 88 168 Z"
          fill="hsl(var(--primary) / 0.1)"
          stroke={primary}
          strokeWidth={strokeW}
          strokeLinejoin="round"
        />
        <line x1={88} y1={72} x2={88} y2={168} stroke={primary} strokeWidth={strokeW} />
        <line x1={36} y1={96} x2={76} y2={96} stroke={primary} strokeWidth={1.5} opacity={0.45} />
        <line x1={36} y1={112} x2={68} y2={112} stroke={primary} strokeWidth={1.5} opacity={0.45} />
        <line x1={36} y1={128} x2={72} y2={128} stroke={primary} strokeWidth={1.5} opacity={0.45} />
        <line x1={100} y1={96} x2={140} y2={96} stroke={primary} strokeWidth={1.5} opacity={0.45} />
        <line x1={100} y1={112} x2={132} y2={112} stroke={primary} strokeWidth={1.5} opacity={0.45} />

        {/* Competency grid */}
        {[0, 1, 2].map((row) =>
          [0, 1, 2].map((col) => (
            <rect
              key={`${row}-${col}`}
              x={168 + col * 28}
              y={48 + row * 28}
              width={22}
              height={22}
              rx={4}
              fill={row === 1 && col === 1 ? "hsl(var(--secondary) / 0.2)" : mutedFill}
              stroke={row === 1 && col === 1 ? secondary : primary}
              strokeWidth={strokeW}
            />
          )),
        )}

        {/* Learning graph nodes */}
        <circle cx={196} cy={104} r={5} fill={secondary} opacity={0.35} stroke={secondary} strokeWidth={strokeW} />
        <circle cx={248} cy={88} r={5} fill={primary} opacity={0.35} stroke={primary} strokeWidth={strokeW} />
        <circle cx={248} cy={136} r={5} fill={secondary} opacity={0.35} stroke={secondary} strokeWidth={strokeW} />
        <line x1={201} y1={104} x2={243} y2={88} stroke={secondary} strokeWidth={1.5} opacity={0.5} />
        <line x1={201} y1={104} x2={243} y2={136} stroke={primary} strokeWidth={1.5} opacity={0.5} />
        <line x1={248} y1={93} x2={248} y2={131} stroke={secondary} strokeWidth={1.5} opacity={0.4} />

        {/* Community silhouettes */}
        <SimplePerson x={248} y={152} color={primary} scale={1.15} />
        <SimplePerson x={276} y={160} color={secondary} scale={0.95} />
        <SimplePerson x={220} y={160} color={secondary} scale={0.95} />

        {/* Playful spark */}
        <path
          d="M292 52 L296 44 L300 52 L308 56 L300 60 L296 68 L292 60 L284 56 Z"
          stroke={secondary}
          strokeWidth={1.5}
          fill="hsl(var(--secondary) / 0.15)"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
